(function () {
  var blockedPatterns = [
    'dtag.js'
  ];

  function hasMarketingConsent() {
    return (
      window.Shopify &&
      Shopify.customerPrivacy &&
      Shopify.customerPrivacy.marketingAllowed &&
      Shopify.customerPrivacy.marketingAllowed()
    );
  }

  function isBlockedScript(node) {
    return (
      node &&
      node.tagName === 'SCRIPT' &&
      node.src &&
      blockedPatterns.some(function (pattern) {
        return node.src.indexOf(pattern) !== -1;
      }) &&
      !hasMarketingConsent()
    );
  }

  function rememberBlockedScript(node) {
    window.__blockedDtagScripts = window.__blockedDtagScripts || [];

    if (!window.__blockedDtagScripts.some(function (item) {
      return item.src === node.src;
    })) {
      window.__blockedDtagScripts.push({
        src: node.src,
        async: node.async,
        defer: node.defer
      });
    }
  }

  function loadBlockedScriptsAfterConsent() {
    if (!hasMarketingConsent()) return;

    window.__blockedDtagScripts = window.__blockedDtagScripts || [];

    window.__blockedDtagScripts.forEach(function (item) {
      if (document.querySelector('script[src="' + item.src + '"]')) return;

      var s = document.createElement('script');
      s.src = item.src;
      s.async = item.async !== false;
      s.defer = item.defer === true;
      document.head.appendChild(s);
    });

    window.__blockedDtagScripts = [];
  }

  var originalAppendChild = Element.prototype.appendChild;
  var originalInsertBefore = Element.prototype.insertBefore;

  Element.prototype.appendChild = function (node) {
    if (isBlockedScript(node)) {
      console.warn('Blocked dtag.js before consent:', node.src);
      rememberBlockedScript(node);
      return node;
    }

    return originalAppendChild.call(this, node);
  };

  Element.prototype.insertBefore = function (node, referenceNode) {
    if (isBlockedScript(node)) {
      console.warn('Blocked dtag.js before consent:', node.src);
      rememberBlockedScript(node);
      return node;
    }

    return originalInsertBefore.call(this, node, referenceNode);
  };

  document.addEventListener('visitorConsentCollected', loadBlockedScriptsAfterConsent);
  document.addEventListener('shopify:customer_privacy:loaded', loadBlockedScriptsAfterConsent);

  setTimeout(loadBlockedScriptsAfterConsent, 1000);
})();